import React from "react";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../intelligence-briefing-library/components/ui/tooltip";

const TOOLTIP_CLASS =
  "z-[9999] w-[260px] border border-gray-200 bg-white px-3 py-2.5 font-normal normal-case tracking-normal text-gray-800 shadow-[0_4px_16px_rgba(0,0,0,0.12)]";

type HoverHintProps = {
  /** Element that shows the hint on hover / focus. */
  children: React.ReactElement;
  description: string;
  title?: string;
  side?: "top" | "right" | "bottom" | "left";
};

/** White hover card with an optional bold title and a short description. */
const HoverHint: React.FC<HoverHintProps> = ({
  children,
  description,
  title,
  side = "bottom",
}) => (
  <TooltipProvider delayDuration={150}>
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent
        side={side}
        align="start"
        sideOffset={8}
        className={TOOLTIP_CLASS}
      >
        {title ? (
          <p className="mb-1 text-[12.5px] font-semibold text-gray-900">
            {title}
          </p>
        ) : null}
        <p className="mb-0 text-[12px] leading-snug text-gray-600">
          {description}
        </p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);

export default HoverHint;
